/**
 * created by lei lei
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import {message} from "../view/sysManagement/utils/sysManagementUtils";
import request from "./request";
import SystemBaseInfoComponent from "./SystemBaseInfoComponent";

const _message = message;
export default class RequestComponent extends SystemBaseInfoComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.request=({url,callBack=()=>{},contentType, loading,method,body,haveToken=true,errorCallBack=()=>{},serverVerify={
            serverErrorCallBack:()=>{},
            isShowErrorMsg:true
        }})=>{
            if(!url){
                return;
            }
            request({url, method, contentType, body, loading,callBack, haveToken, message:{info:(e,allData)=>{
                serverVerify.serverErrorCallBack(e,allData);
                console.log("e   :  " , e,allData);
                if(serverVerify.isShowErrorMsg!==false){
                    _message.destroy()
                    _message.error(e)
                }
            }, error:(e)=>{
                errorCallBack(e);
                _message.destroy()
                _message.error(e)
            }}});
        };
    }
}